import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ConsumptionReportOrderResultDto, ConsumptionReportRowDto } from 'src/app/shared/dto/consumption-report-row.dto';
import { ConsumptionReportResolveDto } from 'src/app/shared/dto/consumption-report-resolve.dto';
import { BaseService } from 'src/app/shared/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class ConsumptionReportService extends BaseService {

    constructor(httpClient: HttpClient) {
        super(httpClient, 'articles');
    }

    async resolve(batchNumber: string): Promise<ConsumptionReportResolveDto> {
        const encoded = encodeURIComponent(batchNumber);
        return lastValueFrom(
            this.httpClient.get<ConsumptionReportResolveDto>(`${this.url}/consumption-report/resolve?batchNumber=${encoded}`)
        );
    }

    async getByBatch(batchId: number): Promise<ConsumptionReportRowDto[]> {
        return lastValueFrom(
            this.httpClient.get<ConsumptionReportRowDto[]>(`${this.url}/consumption-report/by-batch/${batchId}`)
        );
    }

    async getByPackaging(packagingId: number): Promise<ConsumptionReportRowDto[]> {
        return lastValueFrom(
            this.httpClient.get<ConsumptionReportRowDto[]>(`${this.url}/consumption-report/by-packaging/${packagingId}`)
        );
    }

    async searchOrders(q: string): Promise<ConsumptionReportOrderResultDto[]> {
        const encoded = encodeURIComponent(q);
        return lastValueFrom(
            this.httpClient.get<ConsumptionReportOrderResultDto[]>(`${this.url}/consumption-report/search-orders?q=${encoded}`)
        );
    }

    async recalculateByOrder(orderId: number): Promise<void> {
        await lastValueFrom(
            this.httpClient.post<void>(`${this.url}/consumption-report/recalculate-by-order/${orderId}`, {})
        );
    }

    async getByOrder(orderId: number): Promise<ConsumptionReportRowDto[]> {
        return lastValueFrom(
            this.httpClient.get<ConsumptionReportRowDto[]>(`${this.url}/consumption-report/by-order/${orderId}`)
        );
    }
}
